<script>

    import {onMount} from "svelte";
    import {mainTimeline} from "../timelines/main-timeline";


    const animationObj = {
        autoAlpha: 0,
        scale: 0.5
    }

    onMount(() => {
        mainTimeline.from('.chart-button-container', animationObj, 'threeLeadersStart')
        mainTimeline.to('.chart-button-container', animationObj, 'threeLeadersEnd+=0.5')
    });

</script>

<div class="chart-button-container">
    <button on:click>
        <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62">
            <g id="Component_8_10" data-name="Component 8 – 10">
                <circle id="Ellipse_11" data-name="Ellipse 11" cx="31" cy="31" r="31"/>
            </g>
            <g id="Component_16_1" data-name="Component 16 – 1" transform="translate(20.5 16)">
                <g id="Group_779" data-name="Group 779" transform="translate(-20.5 -16)">
                    <rect id="Rectangle_375" data-name="Rectangle 375" width="3" height="15" transform="translate(20.5 31)" fill="#fff"/>
                    <rect id="Rectangle_376" data-name="Rectangle 376" width="3" height="30" transform="translate(26.5 16)" fill="#fff"/>
                    <rect id="Rectangle_377" data-name="Rectangle 377" width="3" height="20" transform="translate(32.5 26)" fill="#fff"/>
                    <rect id="Rectangle_378" data-name="Rectangle 378" width="3" height="25" transform="translate(38.5 21)" fill="#fff"/>
                </g>
            </g>
        </svg>

    </button>
</div>

<style>
    .chart-button-container {
        position: absolute;
        display: inline-block;
        top: 350px;
        left: 62%;
        z-index: 3;
    }

    button {
        display: inline-block;
        border: none;
        padding: 1rem 2rem;
        margin: 0;
        text-decoration: none;
        background: none;
        color: #ffffff;
        font-family: sans-serif;
        font-size: 1rem;
        cursor: pointer;
        text-align: center;
        transition: background 250ms ease-in-out,
        transform 150ms ease;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    button:hover,
    button:focus {
        background: none;
    }

    button:focus {
        outline: none;
        outline-offset: -4px;
    }

    button:active:not(:disabled) {
        transform: scale(0.9);
    }

    button:disabled {
        opacity: 0.6;
        cursor: default;
    }
</style>